export function Lost() {
  return (
    <svg
      className="animated"
      id="freepik_stories-lost"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="freepik--Floor--inject-26"
        style={{ transformOrigin: " 249px 341.6px 0px" }}
        className="animable"
      >
        <g
          id="freepik--floor--inject-26"
          style={{ transformOrigin: " 249px 341.6px 0px" }}
          className="animable"
        >
          <ellipse
            id="freepik--floor--inject-26"
            cx="249"
            cy="341.6"
            rx="217.1"
            ry="125.34"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: " 249px 341.6px 0px",
            }}
            className="animable"
          ></ellipse>
          <path
            id="freepik--Road--inject-26"
            d="M466.1,341.48c-.05-28.74-17.12-57.47-51.2-80.73l-1.83-1.23L106.83,436.33h0l1.89.93C149,457,198.9,466.91,248.78,466.94Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 286.465px 363.23px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Shadows--inject-26"
        style={{ transformOrigin: " 214.03px 315.835px 0px" }}
        className="animable"
      >
        <ellipse
          id="freepik--Shadow--inject-26"
          cx="199.81"
          cy="250.7"
          rx="38.24"
          ry="22.08"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: " 199.81px 250.7px 0px",
          }}
          className="animable"
        ></ellipse>
        <g id="freepik--shadow--inject-26">
          <ellipse
            cx="319.42"
            cy="370.63"
            rx="56.15"
            ry="32.42"
            style={{
              opacity: "0.05",
              transformOrigin: " 319.42px 370.63px 0px",
            }}
            className="animable"
          ></ellipse>
        </g>
        <ellipse
          id="freepik--shadow--inject-26"
          cx="96.67"
          cy="356.54"
          rx="44.18"
          ry="25.51"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: " 96.67px 356.54px 0px",
          }}
          className="animable"
        ></ellipse>
      </g>
      <g
        id="freepik--Trees--inject-26"
        style={{ transformOrigin: " 145.528px 217.075px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Pine--inject-26"
          style={{ transformOrigin: " 199.653px 156.545px 0px" }}
          className="animable"
        >
          <path
            d="M191,143.5v107c0,1.28.85,2.57,2.55,3.55a13.62,13.62,0,0,0,12.28,0c1.7-1,2.55-2.27,2.55-3.55v-107Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: " 199.69px 199.506px 0px",
            }}
            id="elwqv5q8ruyf"
            className="animable"
          ></path>
          <path
            d="M257.21,198.86,203.4,68.9h-7.5l-53.82,130a6.89,6.89,0,0,0,5,9.38l.88.17a6.87,6.87,0,0,1,5.48,7.6h0a6.89,6.89,0,0,0,8.85,7.43l2.66-.82a6.87,6.87,0,0,1,8.28,3.73l2.68,5.9a6.88,6.88,0,0,0,9.77,3.08l10.44-6.19a6.85,6.85,0,0,1,7,0l10.44,6.19a6.88,6.88,0,0,0,9.77-3.08l2.67-5.9a6.88,6.88,0,0,1,8.29-3.73l2.66.81a6.87,6.87,0,0,0,8.84-7.42h0a6.89,6.89,0,0,1,5.49-7.6l.88-.17A6.88,6.88,0,0,0,257.21,198.86Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 199.653px 152.615px 0px",
            }}
            id="elxfweo6vu35o"
            className="animable"
          ></path>
          <g id="ela9ffss0s8nr">
            <path
              d="M257.21,198.86,203.4,68.9h-7.5l-53.82,130a6.89,6.89,0,0,0,5,9.38l.88.17a6.87,6.87,0,0,1,5.48,7.6h0a6.89,6.89,0,0,0,8.85,7.43l2.66-.82a6.87,6.87,0,0,1,8.28,3.73l2.68,5.9a6.88,6.88,0,0,0,9.77,3.08l10.44-6.19a6.85,6.85,0,0,1,7,0l10.44,6.19a6.88,6.88,0,0,0,9.77-3.08l2.67-5.9a6.88,6.88,0,0,1,8.29-3.73l2.66.81a6.87,6.87,0,0,0,8.84-7.42h0a6.89,6.89,0,0,1,5.49-7.6l.88-.17A6.88,6.88,0,0,0,257.21,198.86Z"
              style={{
                opacity: "0.3",
                transformOrigin: " 199.653px 152.615px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <g id="elu71n2xl497n">
            <path
              d="M189.89,83.42l6-13.66h7.5l9.94,23.15,32.48,78.43a4,4,0,0,1-3.39,3.22h0a5.2,5.2,0,0,0-4.32,5.73l.11,1a5.19,5.19,0,0,1-7,5.46l-2.66-1a5.2,5.2,0,0,0-6.6,2.74l-3.3,7.41a5.22,5.22,0,0,1-7.42,2.35l-8.92-6a5.2,5.2,0,0,0-5.33,0l-9.95,6a5.22,5.22,0,0,1-7.42-2.35l-3.3-7.41a5.2,5.2,0,0,0-6.6-2.74l-2.66,1a5.2,5.2,0,0,1-7-5.46l.12-1a5.2,5.2,0,0,0-4.32-5.73,3.92,3.92,0,0,1-2.88-1.92Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 199.39px 134.369px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M245.21,161.08,203.4,63.71h-7.5L153,161.08c-1.54,3.13-.66,6.86,2.79,7.43a5.2,5.2,0,0,1,4.32,5.73l-.12,1a5.21,5.21,0,0,0,7,5.47l2.66-1a5.2,5.2,0,0,1,6.6,2.74l3.3,7.41a5.2,5.2,0,0,0,7.42,2.35l9.95-5.94a5.2,5.2,0,0,1,5.33,0l8.92,5.94a5.2,5.2,0,0,0,7.42-2.35l3.3-7.41a5.2,5.2,0,0,1,6.6-2.74l2.66,1a5.2,5.2,0,0,0,7-5.47l-.11-1a5.21,5.21,0,0,1,4.32-5.74h0C245.88,167.94,246.76,164.21,245.21,161.08Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 199.107px 128.328px 0px",
            }}
            id="elk1uixpg6kw"
            className="animable"
          ></path>
          <g id="elzzcr63cxa9r">
            <path
              d="M245.21,161.08,203.4,63.71h-7.5L153,161.08c-1.54,3.13-.66,6.86,2.79,7.43a5.2,5.2,0,0,1,4.32,5.73l-.12,1a5.21,5.21,0,0,0,7,5.47l2.66-1a5.2,5.2,0,0,1,6.6,2.74l3.3,7.41a5.2,5.2,0,0,0,7.42,2.35l9.95-5.94a5.2,5.2,0,0,1,5.33,0l8.92,5.94a5.2,5.2,0,0,0,7.42-2.35l3.3-7.41a5.2,5.2,0,0,1,6.6-2.74l2.66,1a5.2,5.2,0,0,0,7-5.47l-.11-1a5.21,5.21,0,0,1,4.32-5.74h0C245.88,167.94,246.76,164.21,245.21,161.08Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 199.107px 128.328px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <g id="elhpwecsc2ey4">
            <path
              d="M195.9,63.71h7.5l30.47,70.95a4.25,4.25,0,0,1-.77.54l-.23.13a4.72,4.72,0,0,0-2.38,4.49h0a4.68,4.68,0,0,1-5.86,4.93l-1.82-.48a4.68,4.68,0,0,0-5.32,2.32L215,151.24a4.7,4.7,0,0,1-6.3,1.94l-6.88-3.6a4.69,4.69,0,0,0-4.34,0l-6.88,3.6a4.7,4.7,0,0,1-6.3-1.94l-2.49-4.65a4.69,4.69,0,0,0-5.33-2.32l-1.81.48a4.68,4.68,0,0,1-5.86-4.93,4.69,4.69,0,0,0-2.38-4.48l-.23-.13a4.73,4.73,0,0,1-1.29-1.09Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 199.39px 108.709px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M234.8,122.78,203.37,56.71l-.25-.4a4,4,0,0,0-6.94,0l-.25.41L164.5,122.78a4.68,4.68,0,0,0,1.7,6.55l.23.13a4.7,4.7,0,0,1,2.38,4.48,4.68,4.68,0,0,0,5.86,4.93l1.81-.48a4.7,4.7,0,0,1,5.33,2.32l2.49,4.65a4.69,4.69,0,0,0,6.3,1.94l6.88-3.59a4.69,4.69,0,0,1,4.34,0l6.88,3.59a4.69,4.69,0,0,0,6.3-1.94l2.49-4.65a4.69,4.69,0,0,1,5.32-2.32l1.82.48a4.68,4.68,0,0,0,5.86-4.93h0a4.7,4.7,0,0,1,2.38-4.48l.23-.13A4.68,4.68,0,0,0,234.8,122.78Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 199.65px 101.066px 0px",
            }}
            id="elxdz0q7yrpxf"
            className="animable"
          ></path>
          <g id="elyrupwkudqye">
            <path
              d="M234.8,122.78,203.37,56.71l-.25-.4a4,4,0,0,0-6.94,0l-.25.41L164.5,122.78a4.68,4.68,0,0,0,1.7,6.55l.23.13a4.7,4.7,0,0,1,2.38,4.48,4.68,4.68,0,0,0,5.86,4.93l1.81-.48a4.7,4.7,0,0,1,5.33,2.32l2.49,4.65a4.69,4.69,0,0,0,6.3,1.94l6.88-3.59a4.69,4.69,0,0,1,4.34,0l6.88,3.59a4.69,4.69,0,0,0,6.3-1.94l2.49-4.65a4.69,4.69,0,0,1,5.32-2.32l1.82.48a4.68,4.68,0,0,0,5.86-4.93h0a4.7,4.7,0,0,1,2.38-4.48l.23-.13A4.68,4.68,0,0,0,234.8,122.78Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 199.65px 101.066px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M195.46,253.82a5.34,5.34,0,0,0-10.67,0v.3a2.73,2.73,0,0,0,1.56,2,8.37,8.37,0,0,0,7.55,0,2.75,2.75,0,0,0,1.56-2v-.3Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 190.125px 252.865px 0px",
            }}
            id="el9592dsd2jdt"
            className="animable"
          ></path>
          <path
            d="M193.9,256.15a2.75,2.75,0,0,0,1.56-2v-.3a5.33,5.33,0,0,0-2.78-4.53c0,.06,2.66,3.35.72,5.55-1.34,1.52-6,1.8-8,.6a3.61,3.61,0,0,0,.92.71A8.37,8.37,0,0,0,193.9,256.15Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 190.43px 253.196px 0px",
            }}
            id="ellcmkaveyxyb"
            className="animable"
          ></path>
          <path
            d="M186.83,256.51a3.77,3.77,0,0,0-7.53,0v.21a1.93,1.93,0,0,0,1.1,1.43,5.89,5.89,0,0,0,5.33,0,1.93,1.93,0,0,0,1.1-1.43.41.41,0,0,0,0-.11A.34.34,0,0,0,186.83,256.51Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 183.067px 255.861px 0px",
            }}
            id="ellyidbrk6f0j"
            className="animable"
          ></path>
          <path
            d="M185.73,258.15a1.93,1.93,0,0,0,1.1-1.43.41.41,0,0,0,0-.11.34.34,0,0,0,0-.1,3.71,3.71,0,0,0-.25-1.25c.09,1.61-.67,2.59-3.05,2.9s-3.94-.71-4.14-1.08a2.14,2.14,0,0,0,1,1.07A5.89,5.89,0,0,0,185.73,258.15Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 183.112px 257.025px 0px",
            }}
            id="elwfvhtpvf7e"
            className="animable"
          ></path>
          <path
            d="M214.46,252.74a3.74,3.74,0,0,0-7.47,0,.34.34,0,0,0,0,.1.41.41,0,0,0,0,.11,1.88,1.88,0,0,0,1.09,1.42,5.87,5.87,0,0,0,5.29,0,1.91,1.91,0,0,0,1.09-1.42v-.21Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 210.723px 252.097px 0px",
            }}
            id="elce742r7718g"
            className="animable"
          ></path>
          <path
            d="M213.37,254.37a1.91,1.91,0,0,0,1.09-1.42v-.21a3.6,3.6,0,0,0-.25-1.24c.09,1.6-.67,2.57-3,2.87s-3.91-.7-4.11-1.06a2.16,2.16,0,0,0,1,1.06A5.87,5.87,0,0,0,213.37,254.37Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 210.78px 253.247px 0px",
            }}
            id="eltzlamwbp6i"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--pine--inject-26"
          style={{ transformOrigin: " 96.0978px 255.667px 0px" }}
          className="animable"
        >
          <path
            d="M105.5,241.57V357.16c0,1.39-.92,2.78-2.75,3.84a14.72,14.72,0,0,1-13.28,0c-1.83-1.06-2.74-2.45-2.74-3.84V241.57Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: " 96.115px 302.076px 0px",
            }}
            id="el585ctn9ha1n"
            className="animable"
          ></path>
          <path
            d="M33.91,301.4,92.06,161h8.1l58.16,140.46a7.43,7.43,0,0,1-5.42,10.13l-1,.19a7.44,7.44,0,0,0-5.93,8.21h0a7.43,7.43,0,0,1-9.56,8l-2.87-.88a7.43,7.43,0,0,0-9,4l-2.89,6.38a7.43,7.43,0,0,1-10.56,3.32L99.9,334.12a7.46,7.46,0,0,0-7.58,0L81,340.81a7.43,7.43,0,0,1-10.56-3.32l-2.89-6.38a7.43,7.43,0,0,0-9-4l-2.88.88a7.43,7.43,0,0,1-9.56-8h0a7.42,7.42,0,0,0-5.92-8.21l-1-.19A7.43,7.43,0,0,1,33.91,301.4Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 96.0978px 251.426px 0px",
            }}
            id="elw6qanqmvs0n"
            className="animable"
          ></path>
          <g id="elr3g2kn8d5yj">
            <path
              d="M33.91,301.4,92.06,161h8.1l58.16,140.46a7.43,7.43,0,0,1-5.42,10.13l-1,.19a7.44,7.44,0,0,0-5.93,8.21h0a7.43,7.43,0,0,1-9.56,8l-2.87-.88a7.43,7.43,0,0,0-9,4l-2.89,6.38a7.43,7.43,0,0,1-10.56,3.32L99.9,334.12a7.46,7.46,0,0,0-7.58,0L81,340.81a7.43,7.43,0,0,1-10.56-3.32l-2.89-6.38a7.43,7.43,0,0,0-9-4l-2.88.88a7.43,7.43,0,0,1-9.56-8h0a7.42,7.42,0,0,0-5.92-8.21l-1-.19A7.43,7.43,0,0,1,33.91,301.4Z"
              style={{
                opacity: "0.3",
                transformOrigin: " 96.0978px 251.426px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <g id="elb2zac3asha">
            <path
              d="M106.66,176.64l-6.5-14.76h-8.1l-10.74,25-35.1,84.76a4.32,4.32,0,0,0,3.66,3.47h0a5.63,5.63,0,0,1,4.67,6.2l-.12,1.08a5.62,5.62,0,0,0,7.58,5.9l2.87-1.1a5.63,5.63,0,0,1,7.14,3l3.56,8a5.61,5.61,0,0,0,8,2.54l9.65-6.42a5.6,5.6,0,0,1,5.75,0l10.77,6.42a5.62,5.62,0,0,0,8-2.54l3.56-8a5.63,5.63,0,0,1,7.14-3l2.87,1.1a5.62,5.62,0,0,0,7.58-5.9l-.12-1.08a5.63,5.63,0,0,1,4.67-6.2,4.22,4.22,0,0,0,3.11-2.07Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 96.39px 231.701px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M46.87,260.56,92.06,155.34h8.1l46.32,105.22c1.66,3.39.71,7.42-3,8a5.63,5.63,0,0,0-4.67,6.2l.12,1.07a5.62,5.62,0,0,1-7.58,5.9l-2.87-1.09a5.63,5.63,0,0,0-7.14,3l-3.56,8a5.63,5.63,0,0,1-8,2.54L99,287.75a5.6,5.6,0,0,0-5.75,0l-9.65,6.43a5.63,5.63,0,0,1-8-2.54l-3.56-8a5.63,5.63,0,0,0-7.14-3L62,281.76a5.62,5.62,0,0,1-7.58-5.9l.12-1.08a5.62,5.62,0,0,0-4.67-6.19h0C46.16,268,45.2,263.94,46.87,260.56Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 96.6728px 225.152px 0px",
            }}
            id="elvo2ptixmv8h"
            className="animable"
          ></path>
          <g id="el8qkz2pck013">
            <path
              d="M46.87,260.56,92.06,155.34h8.1l46.32,105.22c1.66,3.39.71,7.42-3,8a5.63,5.63,0,0,0-4.67,6.2l.12,1.07a5.62,5.62,0,0,1-7.58,5.9l-2.87-1.09a5.63,5.63,0,0,0-7.14,3l-3.56,8a5.63,5.63,0,0,1-8,2.54L99,287.75a5.6,5.6,0,0,0-5.75,0l-9.65,6.43a5.63,5.63,0,0,1-8-2.54l-3.56-8a5.63,5.63,0,0,0-7.14-3L62,281.76a5.62,5.62,0,0,1-7.58-5.9l.12-1.08a5.62,5.62,0,0,0-4.67-6.19h0C46.16,268,45.2,263.94,46.87,260.56Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 96.6728px 225.152px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <g id="el5vy943bhhmy">
            <path
              d="M100.16,155.34h-8.1L59.13,232a4.92,4.92,0,0,0,.83.58l.25.14a5.06,5.06,0,0,1,2.57,4.85h0a5.07,5.07,0,0,0,6.34,5.33l2-.52a5.05,5.05,0,0,1,5.75,2.5l2.7,5a5.05,5.05,0,0,0,6.8,2.09l7.44-3.88a5,5,0,0,1,4.69,0l7.43,3.88a5.07,5.07,0,0,0,6.81-2.09l2.69-5a5.07,5.07,0,0,1,5.76-2.5l2,.52a5.06,5.06,0,0,0,6.33-5.33,5.07,5.07,0,0,1,2.57-4.84l.26-.15a4.75,4.75,0,0,0,1.38-1.17Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 96.43px 203.945px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M58.13,219.18l34-71.4.26-.43a4.32,4.32,0,0,1,7.5,0l.28.44,34,71.39a5.07,5.07,0,0,1-1.83,7.08l-.26.14a5.07,5.07,0,0,0-2.57,4.84,5.06,5.06,0,0,1-6.33,5.33l-2-.52a5.07,5.07,0,0,0-5.76,2.5l-2.69,5a5.07,5.07,0,0,1-6.81,2.09l-7.43-3.88a5,5,0,0,0-4.69,0l-7.44,3.88a5.05,5.05,0,0,1-6.8-2.09l-2.7-5a5.05,5.05,0,0,0-5.75-2.5l-2,.52a5.07,5.07,0,0,1-6.34-5.33h0a5,5,0,0,0-2.57-4.84l-.25-.15A5.06,5.06,0,0,1,58.13,219.18Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 96.149px 195.697px 0px",
            }}
            id="elpbq8vzzgcyr"
            className="animable"
          ></path>
          <g id="el10psugnq52b">
            <path
              d="M58.13,219.18l34-71.4.26-.43a4.32,4.32,0,0,1,7.5,0l.28.44,34,71.39a5.07,5.07,0,0,1-1.83,7.08l-.26.14a5.07,5.07,0,0,0-2.57,4.84,5.06,5.06,0,0,1-6.33,5.33l-2-.52a5.07,5.07,0,0,0-5.76,2.5l-2.69,5a5.07,5.07,0,0,1-6.81,2.09l-7.43-3.88a5,5,0,0,0-4.69,0l-7.44,3.88a5.05,5.05,0,0,1-6.8-2.09l-2.7-5a5.05,5.05,0,0,0-5.75-2.5l-2,.52a5.07,5.07,0,0,1-6.34-5.33h0a5,5,0,0,0-2.57-4.84l-.25-.15A5.06,5.06,0,0,1,58.13,219.18Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 96.149px 195.697px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M100.64,360.79a5.77,5.77,0,0,1,11.53,0v.32a3,3,0,0,1-1.68,2.2,9,9,0,0,1-8.16,0,3,3,0,0,1-1.69-2.2v-.32Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 106.405px 359.774px 0px",
            }}
            id="ele83olp6zi3c"
            className="animable"
          ></path>
          <path
            d="M102.33,363.31a3,3,0,0,1-1.69-2.2v-.32a5.76,5.76,0,0,1,3-4.89c0,.05-2.87,3.61-.77,6,1.45,1.64,6.43,1.94,8.61.65a4.79,4.79,0,0,1-1,.77A9,9,0,0,1,102.33,363.31Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 106.06px 360.095px 0px",
            }}
            id="elqjvkw0m1kff"
            className="animable"
          ></path>
          <path
            d="M110,363.69a4.07,4.07,0,0,1,8.14,0,.45.45,0,0,1,0,.11.49.49,0,0,1,0,.12,2.07,2.07,0,0,1-1.19,1.55,6.36,6.36,0,0,1-5.76,0,2.12,2.12,0,0,1-1.19-1.55v-.23Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 114.072px 362.891px 0px",
            }}
            id="el7czj0fiuoo"
            className="animable"
          ></path>
          <path
            d="M111.15,365.47a2.12,2.12,0,0,1-1.19-1.55v-.23a4.06,4.06,0,0,1,.28-1.35c-.1,1.75.72,2.8,3.3,3.13s4.25-.76,4.47-1.16a2.33,2.33,0,0,1-1.1,1.16A6.36,6.36,0,0,1,111.15,365.47Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 113.985px 364.25px 0px",
            }}
            id="elotoya76h3bh"
            className="animable"
          ></path>
          <path
            d="M80.11,359.62a4,4,0,0,1,8.07,0,.61.61,0,0,1,0,.22A2,2,0,0,1,87,361.38a6.31,6.31,0,0,1-5.71,0,2.07,2.07,0,0,1-1.18-1.54.61.61,0,0,1,0-.22Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 84.145px 358.824px 0px",
            }}
            id="el40mkdth8y6a"
            className="animable"
          ></path>
          <path
            d="M81.29,361.38a2.07,2.07,0,0,1-1.18-1.54.61.61,0,0,1,0-.22,3.9,3.9,0,0,1,.27-1.34c-.1,1.73.72,2.78,3.27,3.11s4.22-.76,4.44-1.16A2.33,2.33,0,0,1,87,361.38,6.31,6.31,0,0,1,81.29,361.38Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 84.095px 360.171px 0px",
            }}
            id="elq0d0rquozh"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--Plants--inject-26"
          style={{ transformOrigin: " 210.41px 347.216px 0px" }}
          className="animable"
        >
          <path
            d="M220.8,370.33l5.86-3.35s2.81-15.48.71-28.79c-3-18.71-15.69-25.16-20.32-23.3s-5.71,7.4,2.64,18.21C214.62,339.48,221,353,220.8,370.33Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 215.817px 342.457px 0px",
            }}
            id="elyt7rjgfdwd"
            className="animable"
          ></path>
          <g id="eljapfw9u72wd">
            <path
              d="M220.8,370.33l5.86-3.35s2.81-15.48.71-28.79c-3-18.71-15.69-25.16-20.32-23.3s-5.71,7.4,2.64,18.21C214.62,339.48,221,353,220.8,370.33Z"
              style={{
                opacity: "0.3",
                transformOrigin: " 215.817px 342.457px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M222.93,362.9h-.06a.42.42,0,0,1-.36-.47c2.42-17.52-4.62-36.71-12.54-44.44a.42.42,0,0,1,0-.59.41.41,0,0,1,.59,0c8.06,7.88,15.24,27.38,12.78,45.16A.43.43,0,0,1,222.93,362.9Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: " 216.84px 340.087px 0px",
            }}
            id="elaesff16o5jr"
            className="animable"
          ></path>
          <path
            d="M204.55,379.71c-.92.54-2.83-.63-3.56-1.12a8.79,8.79,0,0,1-2.94-3.37,8.25,8.25,0,0,1-.73-5,18.43,18.43,0,0,1,.63-2.64c.24-.86.49-1.71.73-2.57a6.38,6.38,0,0,0,.38-2.59c-.22-1.75-1.78-3-3.2-4s-3.2-2.72-3.19-4.83a7.47,7.47,0,0,1,1.86-4.43c1-1.28,2.21-2.41,3.13-3.76a5.19,5.19,0,0,0,1.06-3.28,5.63,5.63,0,0,0-.71-2.05,28.89,28.89,0,0,1-2.25-4.11,4.17,4.17,0,0,1,.71-4.38,4.87,4.87,0,0,1,3.64-.9,8.36,8.36,0,0,1,3.38,1.19c3.35,1.86,5.27,5.84,8.83,7.27a32.89,32.89,0,0,0,4.3,1.05,5.34,5.34,0,0,1,3.56,2.44c1.3,2.61-1.12,5.82-.2,8.59.81,2.45,3.19,3.39,4.53,5.6a5.23,5.23,0,0,1,.62,3.21,15.5,15.5,0,0,1-1.35,5.42,38,38,0,0,1-3,4.89C220.75,370.38,204.7,379.63,204.55,379.71Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 208.921px 355.236px 0px",
            }}
            id="el4hgbul3o7ra"
            className="animable"
          ></path>
          <g id="elou5jdf3315k">
            <path
              d="M204.55,379.71c-.92.54-2.83-.63-3.56-1.12a8.79,8.79,0,0,1-2.94-3.37,8.25,8.25,0,0,1-.73-5,18.43,18.43,0,0,1,.63-2.64c.24-.86.49-1.71.73-2.57a6.38,6.38,0,0,0,.38-2.59c-.22-1.75-1.78-3-3.2-4s-3.2-2.72-3.19-4.83a7.47,7.47,0,0,1,1.86-4.43c1-1.28,2.21-2.41,3.13-3.76a5.19,5.19,0,0,0,1.06-3.28,5.63,5.63,0,0,0-.71-2.05,28.89,28.89,0,0,1-2.25-4.11,4.17,4.17,0,0,1,.71-4.38,4.87,4.87,0,0,1,3.64-.9,8.36,8.36,0,0,1,3.38,1.19c3.35,1.86,5.27,5.84,8.83,7.27a32.89,32.89,0,0,0,4.3,1.05,5.34,5.34,0,0,1,3.56,2.44c1.3,2.61-1.12,5.82-.2,8.59.81,2.45,3.19,3.39,4.53,5.6a5.23,5.23,0,0,1,.62,3.21,15.5,15.5,0,0,1-1.35,5.42,38,38,0,0,1-3,4.89C220.75,370.38,204.7,379.63,204.55,379.71Z"
              style={{
                opacity: "0.15",
                transformOrigin: " 208.921px 355.236px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M214.06,374.65h0a.43.43,0,0,1-.41-.44c.69-16.58-7.12-34.88-12.8-40.2a.41.41,0,0,1,0-.59.42.42,0,0,1,.59,0c5.8,5.43,13.77,24,13.07,40.85A.43.43,0,0,1,214.06,374.65Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: " 207.639px 353.975px 0px",
            }}
            id="elsz3qmxb48fe"
            className="animable"
          ></path>
          <path
            d="M211.58,355.06a.32.32,0,0,1-.13,0,56.28,56.28,0,0,0-12-1.94.42.42,0,1,1,0-.83,57.29,57.29,0,0,1,12.24,2,.44.44,0,0,1,.28.53A.42.42,0,0,1,211.58,355.06Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: " 205.475px 353.676px 0px",
            }}
            id="elfmcwkk8mhkp"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Signals--inject-26"
        style={{ transformOrigin: " 435.795px 221.02px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Signal--inject-26"
          style={{ transformOrigin: " 435.795px 221.02px 0px" }}
          className="animable"
        >
          <path
            d="M439.55,126.11a1.91,1.91,0,0,0-1.1-1.51,6,6,0,0,0-5.36,0,1.92,1.92,0,0,0-1.11,1.51h0V315.94c0,1.18,1.69,2.14,3.78,2.14s3.79-1,3.79-2.14h0V126.11Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 435.765px 221.024px 0px",
            }}
            id="el4wn8lyr4ko"
            className="animable"
          ></path>
          <ellipse
            cx="435.76"
            cy="126.11"
            rx="3.79"
            ry="2.15"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 435.76px 126.11px 0px",
            }}
            id="elx3sqgx7r3jp"
            className="animable"
          ></ellipse>
          <polygon
            points="478.59 198.43 471.16 185.55 421.74 157.04 418 159.2 418 176.36 467.42 204.87 471.23 202.77 478.59 198.43"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 448.295px 180.955px 0px",
            }}
            id="elrweh6duyap"
            className="animable"
          ></polygon>
          <polygon
            points="418 159.2 467.42 187.71 474.85 200.58 467.42 204.87 418 176.36 418 159.2"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 446.425px 182.035px 0px",
            }}
            id="el1j166t45bdk"
            className="animable"
          ></polygon>
          <g id="elbc0dzz1c3sv">
            <g
              style={{
                opacity: "0.3",
                transformOrigin: " 446.435px 182.035px 0px",
              }}
              className="animable"
            >
              <polygon
                points="418 159.2 467.42 187.71 474.87 200.62 467.42 204.87 418 176.36 418 159.2"
                id="elo51xvwu2xvi"
                style={{ transformOrigin: " 446.435px 182.035px 0px" }}
                className="animable"
              ></polygon>
            </g>
          </g>
          <g id="eladz4vxpj20j">
            <polygon
              points="471.16 185.55 467.42 187.71 418 159.2 421.74 157.04 471.16 185.55"
              style={{
                opacity: "0.1",
                transformOrigin: " 444.58px 172.375px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <g id="eleyrscsx4dn6">
            <polygon
              points="467.42 187.71 471.16 185.55 478.59 198.43 474.87 200.62 467.42 187.71"
              style={{
                opacity: "0.2",
                transformOrigin: " 473.005px 193.085px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="462.34 154.7 412.92 126.14 405.49 130.43 412.92 143.31 462.34 171.86 462.34 154.7"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 433.915px 149px 0px",
            }}
            id="elbgthk3fdgjf"
            className="animable"
          ></polygon>
          <polygon
            points="412.92 126.14 416.55 123.96 466.05 152.56 462.34 154.7 412.92 126.14"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 439.485px 139.33px 0px",
            }}
            id="elxoo0qnraj5"
            className="animable"
          ></polygon>
          <g id="el8fdsp8wzl9o">
            <g
              style={{
                opacity: "0.4",
                transformOrigin: " 439.485px 139.33px 0px",
              }}
              className="animable"
            >
              <polygon
                points="412.92 126.14 416.55 123.96 466.05 152.56 462.34 154.7 412.92 126.14"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: " 439.485px 139.33px 0px",
                }}
                id="el1pnql9egncd"
                className="animable"
              ></polygon>
            </g>
          </g>
          <polygon
            points="466.05 169.72 462.34 171.86 462.34 154.7 466.05 152.56 466.05 169.72"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 464.195px 162.21px 0px",
            }}
            id="elhsv1vf7h51v"
            className="animable"
          ></polygon>
          <g id="el529b2and5b">
            <polygon
              points="466.05 169.72 462.34 171.86 462.34 154.7 466.05 152.56 466.05 169.72"
              style={{
                opacity: "0.1",
                transformOrigin: " 464.195px 162.21px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="449.85 207.74 400.43 179.18 393 183.47 400.43 196.35 449.85 224.9 449.85 207.74"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 421.425px 202.04px 0px",
            }}
            id="el44rhv36bc8x"
            className="animable"
          ></polygon>
          <polygon
            points="400.43 179.18 404.07 177 453.56 205.6 449.85 207.74 400.43 179.18"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 426.995px 192.37px 0px",
            }}
            id="el7oah5bwivew"
            className="animable"
          ></polygon>
          <g id="el19xqervdjys">
            <g
              style={{
                opacity: "0.4",
                transformOrigin: " 426.995px 192.37px 0px",
              }}
              className="animable"
            >
              <polygon
                points="400.43 179.18 404.07 177 453.56 205.6 449.85 207.74 400.43 179.18"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: " 426.995px 192.37px 0px",
                }}
                id="el97lizwzaukv"
                className="animable"
              ></polygon>
            </g>
          </g>
          <polygon
            points="453.56 222.76 449.85 224.9 449.85 207.74 453.56 205.6 453.56 222.76"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 451.705px 215.25px 0px",
            }}
            id="ele7ksackx9vj"
            className="animable"
          ></polygon>
          <g id="elxctl1v6oqd">
            <polygon
              points="453.56 222.76 449.85 224.9 449.85 207.74 453.56 205.6 453.56 222.76"
              style={{
                opacity: "0.1",
                transformOrigin: " 451.705px 215.25px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
        </g>
      </g>
      <g
        id="freepik--question-marks--inject-26"
        style={{ transformOrigin: " 342.392px 114.415px 0px" }}
        className="animable animator-active"
      >
        <g
          id="freepik--question-marks--inject-26"
          style={{ transformOrigin: " 342.392px 114.415px 0px" }}
          className="animable"
        >
          <path
            d="M312.66,79.91a18.53,18.53,0,0,1,5.19-.93,14.3,14.3,0,0,1,5,.67A11.38,11.38,0,0,1,327,82.07a11.11,11.11,0,0,1,3.25,8.31,11.9,11.9,0,0,1-.79,3.45,18.9,18.9,0,0,1-1.53,3.09c-.6,1-1.17,1.91-1.7,2.79a16,16,0,0,0-1.3,2.63,4.72,4.72,0,0,0-.27,2.55,2.18,2.18,0,0,1-.15,1.19,1.26,1.26,0,0,1-.83.76l-4.12,1.36a1.57,1.57,0,0,1-1.2-.09,1.27,1.27,0,0,1-.75-.89,10,10,0,0,1-.33-4,13.79,13.79,0,0,1,.95-3.5,20.22,20.22,0,0,1,1.62-3.1q.94-1.44,1.71-2.76a13,13,0,0,0,1.16-2.49,3.61,3.61,0,0,0,0-2.32,4.3,4.3,0,0,0-2.86-2.81,7.76,7.76,0,0,0-5.05.19q-4.6,1.52-5.25,6.85a3,3,0,0,1-.28,1.08,1.4,1.4,0,0,1-.9.63L304,96.43a1.23,1.23,0,0,1-.94-.05,1.18,1.18,0,0,1-.64-.75,8.79,8.79,0,0,1-.12-4.26,14.23,14.23,0,0,1,1.8-4.57,17,17,0,0,1,3.53-4.08A14.8,14.8,0,0,1,312.66,79.91ZM325,110a1.57,1.57,0,0,1,1.94,1l1.58,4.78a1.49,1.49,0,0,1-.09,1.17,1.52,1.52,0,0,1-.89.78l-4.66,1.54a1.57,1.57,0,0,1-1.95-1l-1.58-4.77a1.56,1.56,0,0,1,1-1.95Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 316.177px 99.153px 0px",
            }}
            id="el0rvxzh31qtbf"
            className="animable"
          ></path>
          <path
            d="M345.69,124.11a13,13,0,0,1,3.44-1.22,9.88,9.88,0,0,1,3.46-.11,7.78,7.78,0,0,1,3.09,1.19A6.79,6.79,0,0,1,358,126.6a7,7,0,0,1,.84,2.66,8.52,8.52,0,0,1-.14,2.43A13.39,13.39,0,0,1,358,134l-.84,2.09a11.87,11.87,0,0,0-.59,1.94,3.2,3.2,0,0,0,.11,1.77,1.47,1.47,0,0,1,0,.83.89.89,0,0,1-.48.61l-2.65,1.39a1.13,1.13,0,0,1-.83.08.86.86,0,0,1-.61-.53,6.8,6.8,0,0,1-.68-2.69,9.71,9.71,0,0,1,.25-2.49,13.37,13.37,0,0,1,.76-2.29c.31-.73.59-1.42.85-2.08a9.18,9.18,0,0,0,.51-1.82,2.61,2.61,0,0,0-.25-1.59,3,3,0,0,0-2.27-1.59,5.37,5.37,0,0,0-3.42.7,5.18,5.18,0,0,0-2.8,5.26,2,2,0,0,1-.07.77,1,1,0,0,1-.54.53l-2.83,1.49a.86.86,0,0,1-.65.07.83.83,0,0,1-.52-.44,6.15,6.15,0,0,1-.56-2.89,9.65,9.65,0,0,1,.71-3.31,11.57,11.57,0,0,1,1.94-3.18A10.34,10.34,0,0,1,345.69,124.11Zm11.81,19.1a1,1,0,0,1,.82-.07,1,1,0,0,1,.62.52l1.62,3.07a1.08,1.08,0,0,1,.07.81,1.09,1.09,0,0,1-.52.63l-3,1.57a1,1,0,0,1-.81.07,1,1,0,0,1-.63-.51l-1.61-3.08a1.07,1.07,0,0,1,.44-1.43Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 350.28px 136.271px 0px",
            }}
            id="elyy5xko2e4oo"
            className="animable"
          ></path>
          <g id="elrxsol8lnrqq">
            <g
              style={{
                opacity: "0.2",
                transformOrigin: " 350.28px 136.271px 0px",
              }}
              className="animable"
            >
              <path
                d="M345.69,124.11a13,13,0,0,1,3.44-1.22,9.88,9.88,0,0,1,3.46-.11,7.78,7.78,0,0,1,3.09,1.19A6.79,6.79,0,0,1,358,126.6a7,7,0,0,1,.84,2.66,8.52,8.52,0,0,1-.14,2.43A13.39,13.39,0,0,1,358,134l-.84,2.09a11.87,11.87,0,0,0-.59,1.94,3.2,3.2,0,0,0,.11,1.77,1.47,1.47,0,0,1,0,.83.89.89,0,0,1-.48.61l-2.65,1.39a1.13,1.13,0,0,1-.83.08.86.86,0,0,1-.61-.53,6.8,6.8,0,0,1-.68-2.69,9.71,9.71,0,0,1,.25-2.49,13.37,13.37,0,0,1,.76-2.29c.31-.73.59-1.42.85-2.08a9.18,9.18,0,0,0,.51-1.82,2.61,2.61,0,0,0-.25-1.59,3,3,0,0,0-2.27-1.59,5.37,5.37,0,0,0-3.42.7,5.18,5.18,0,0,0-2.8,5.26,2,2,0,0,1-.07.77,1,1,0,0,1-.54.53l-2.83,1.49a.86.86,0,0,1-.65.07.83.83,0,0,1-.52-.44,6.15,6.15,0,0,1-.56-2.89,9.65,9.65,0,0,1,.71-3.31,11.57,11.57,0,0,1,1.94-3.18A10.34,10.34,0,0,1,345.69,124.11Zm11.81,19.1a1,1,0,0,1,.82-.07,1,1,0,0,1,.62.52l1.62,3.07a1.08,1.08,0,0,1,.07.81,1.09,1.09,0,0,1-.52.63l-3,1.57a1,1,0,0,1-.81.07,1,1,0,0,1-.63-.51l-1.61-3.08a1.07,1.07,0,0,1,.44-1.43Z"
                id="el7aeq7rgtb67"
                style={{ transformOrigin: " 350.28px 136.271px 0px" }}
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M368,110.29a1.21,1.21,0,0,1,.74.61,1.24,1.24,0,0,1,.1,1l-1.2,3.93a1.29,1.29,0,0,1-1.58.84l-3.84-1.17a1.23,1.23,0,0,1-.74-.62,1.2,1.2,0,0,1-.1-1l1.2-3.93a1.23,1.23,0,0,1,.62-.74,1.24,1.24,0,0,1,1-.1Zm6-25.93a15.2,15.2,0,0,1,3.91,1.83,11.55,11.55,0,0,1,3,2.8,9.34,9.34,0,0,1,1.62,3.57,8.23,8.23,0,0,1-.24,4.15,8.34,8.34,0,0,1-1.51,2.93,10.08,10.08,0,0,1-2.15,1.94,16.63,16.63,0,0,1-2.49,1.34L373.66,104a12.33,12.33,0,0,0-2.1,1.14,3.75,3.75,0,0,0-1.39,1.58,1.77,1.77,0,0,1-.66.72,1,1,0,0,1-.91.12l-3.4-1a1.29,1.29,0,0,1-.76-.62,1.06,1.06,0,0,1-.08-1,8.26,8.26,0,0,1,1.67-2.83,11.29,11.29,0,0,1,2.29-1.89,15.31,15.31,0,0,1,2.55-1.3c.87-.35,1.68-.7,2.44-1a11.11,11.11,0,0,0,1.95-1.11,3,3,0,0,0,1.11-1.55,3.53,3.53,0,0,0-.58-3.22,6.33,6.33,0,0,0-3.46-2.26,6.15,6.15,0,0,0-6.75,2.09,2.71,2.71,0,0,1-.69.6,1.23,1.23,0,0,1-.91,0l-3.62-1.1a1.12,1.12,0,0,1-.61-.48,1,1,0,0,1-.07-.81,7.2,7.2,0,0,1,1.94-2.9,11.44,11.44,0,0,1,3.36-2.2,13.79,13.79,0,0,1,4.28-1.06A12.26,12.26,0,0,1,374,84.36Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 371.158px 100.287px 0px",
            }}
            id="eldwgpg25esqs"
            className="animable"
          ></path>
          <g id="elx6dtu4cvpo">
            <g
              style={{
                opacity: "0.6",
                transformOrigin: " 371.158px 100.287px 0px",
              }}
              className="animable"
            >
              <path
                d="M368,110.29a1.21,1.21,0,0,1,.74.61,1.24,1.24,0,0,1,.1,1l-1.2,3.93a1.29,1.29,0,0,1-1.58.84l-3.84-1.17a1.23,1.23,0,0,1-.74-.62,1.2,1.2,0,0,1-.1-1l1.2-3.93a1.23,1.23,0,0,1,.62-.74,1.24,1.24,0,0,1,1-.1Zm6-25.93a15.2,15.2,0,0,1,3.91,1.83,11.55,11.55,0,0,1,3,2.8,9.34,9.34,0,0,1,1.62,3.57,8.23,8.23,0,0,1-.24,4.15,8.34,8.34,0,0,1-1.51,2.93,10.08,10.08,0,0,1-2.15,1.94,16.63,16.63,0,0,1-2.49,1.34L373.66,104a12.33,12.33,0,0,0-2.1,1.14,3.75,3.75,0,0,0-1.39,1.58,1.77,1.77,0,0,1-.66.72,1,1,0,0,1-.91.12l-3.4-1a1.29,1.29,0,0,1-.76-.62,1.06,1.06,0,0,1-.08-1,8.26,8.26,0,0,1,1.67-2.83,11.29,11.29,0,0,1,2.29-1.89,15.31,15.31,0,0,1,2.55-1.3c.87-.35,1.68-.7,2.44-1a11.11,11.11,0,0,0,1.95-1.11,3,3,0,0,0,1.11-1.55,3.53,3.53,0,0,0-.58-3.22,6.33,6.33,0,0,0-3.46-2.26,6.15,6.15,0,0,0-6.75,2.09,2.71,2.71,0,0,1-.69.6,1.23,1.23,0,0,1-.91,0l-3.62-1.1a1.12,1.12,0,0,1-.61-.48,1,1,0,0,1-.07-.81,7.2,7.2,0,0,1,1.94-2.9,11.44,11.44,0,0,1,3.36-2.2,13.79,13.79,0,0,1,4.28-1.06A12.26,12.26,0,0,1,374,84.36Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: " 371.158px 100.287px 0px",
                }}
                id="elznis4xlh80k"
                className="animable"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g
        id="freepik--Character--inject-26"
        style={{ transformOrigin: " 328.199px 266.207px 0px" }}
        className="animable"
      >
        <g
          id="freepik--character--inject-26"
          style={{ transformOrigin: " 328.199px 266.207px 0px" }}
          className="animable"
        >
          <path
            d="M313.7,348.64a12,12,0,0,1-.44,5.39c-1.06,2.82-3.2,4.07-4.47,5.17a21.4,21.4,0,0,0-3.71,4.32,18.26,18.26,0,0,1-3.88,4.65c-1.2,1-4.52,1-6.11.32s-2.12-1.32-2-3.88,7.93-3.28,7.93-3.28Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 303.451px 358.803px 0px",
            }}
            id="el6l719ocr4i"
            className="animable"
          ></path>
          <path
            d="M294.28,357c-.67.24-.86,1.5-1,4-.12,1.9-1,4.66,1.62,5.91,2.09,1,5.47.44,6.94-1.33,1.82-2.19,3.06-4.13,5.65-6.81,2.25-2.32,4.56-3.07,5.63-7.77.69-3,.22-4.3-1.8-5.21-2.79-1.25-7.28,2.57-9.5,3.14C299.91,349.42,295,356.75,294.28,357Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 303.23px 356.472px 0px",
            }}
            id="el5b4jd9165q4"
            className="animable"
          ></path>
          <g id="elcvatzlqqjpl">
            <path
              d="M294.28,357c-.67.24-.86,1.5-1,4-.12,1.9-1,4.66,1.62,5.91,2.09,1,5.47.44,6.94-1.33,1.82-2.19,3.06-4.13,5.65-6.81,2.25-2.32,4.56-3.07,5.63-7.77.69-3,.22-4.3-1.8-5.21-2.79-1.25-7.28,2.57-9.5,3.14C299.91,349.42,295,356.75,294.28,357Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 303.23px 356.472px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M301.81,348.92l.38-.12a7.25,7.25,0,0,1,6,4.11c.36.84-.81,1.46-1.48.8a7.75,7.75,0,0,0-6-4.09A3.26,3.26,0,0,1,301.81,348.92Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 304.484px 351.394px 0px",
            }}
            id="el91dgayu8wrm"
            className="animable"
          ></path>
          <path
            d="M300,350.32a7.21,7.21,0,0,1,5.57,4.07c.36.83-.81,1.45-1.48.8a7.41,7.41,0,0,0-5-3.89C299.37,351,299.68,350.61,300,350.32Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 302.364px 352.89px 0px",
            }}
            id="el1s1qv1qytix"
            className="animable"
          ></path>
          <path
            d="M348.24,388.16c.39,2.14-.41,3.23-3.18,4.76s-7.1,2-11.6.58-6.63-3.43-8.5-3.94-6.53-.64-8.38-1.22-1.8-1.54-1.75-3.78Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 331.573px 389.455px 0px",
            }}
            id="el9v51ez518h"
            className="animable"
          ></path>
          <path
            d="M316.87,373.82a51.23,51.23,0,0,0-1.46,5c-.42,1.86-1,5-.4,6.37s3.15,2.37,7.1,2.42c2.55,0,6.5,1.85,9.19,3.42s5.84,1.7,8.82,1.41c3.52-.35,7.2-2.31,7.79-3.75s.77-2.53-7.43-6.22c-.08,0-9.53-3.73-13.44-8.23Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 331.454px 383.192px 0px",
            }}
            id="el2yo6llna3j7"
            className="animable"
          ></path>
          <g id="elboalojfnc4u">
            <g
              style={{
                opacity: "0.2",
                transformOrigin: " 331.454px 383.192px 0px",
              }}
              className="animable"
            >
              <path
                d="M316.87,373.82a51.23,51.23,0,0,0-1.46,5c-.42,1.86-1,5-.4,6.37s3.15,2.37,7.1,2.42c2.55,0,6.5,1.85,9.19,3.42s5.84,1.7,8.82,1.41c3.52-.35,7.2-2.31,7.79-3.75s.77-2.53-7.43-6.22c-.08,0-9.53-3.73-13.44-8.23Z"
                id="elm0hroqdmwf"
                style={{ transformOrigin: " 331.454px 383.192px 0px" }}
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M332.42,391.59s.85-7.09,6.66-9c5.26-1.73,9.73,2.22,9.16,5.57C347.85,390.42,341.4,395.42,332.42,391.59Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 340.355px 387.58px 0px",
            }}
            id="elwosdekyhvs"
            className="animable"
          ></path>
          <path
            d="M337.65,381.23a6.73,6.73,0,0,0-4,1.67c-1.69,1.36-1.76,2.29-1.76,2.29a.87.87,0,0,1-1.49-.75s.46-3.57,5.19-4.21A1.94,1.94,0,0,1,337.65,381.23Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 334.018px 382.831px 0px",
            }}
            id="elo30dodizm4"
            className="animable"
          ></path>
          <path
            d="M334.38,379.58a5.88,5.88,0,0,0-4,1.5c-1.69,1.37-1.72,2.47-1.72,2.47a.87.87,0,0,1-1.49-.75s.45-3.58,5.18-4.21A1.92,1.92,0,0,1,334.38,379.58Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 330.768px 381.192px 0px",
            }}
            id="elzovdzvak80n"
            className="animable"
          ></path>
          <path
            d="M331.14,377.65a5.89,5.89,0,0,0-4.1,1.22c-1.78,1.25-1.89,2.34-1.89,2.34a.88.88,0,0,1-1.44-.85s.71-3.53,5.47-3.85A1.92,1.92,0,0,1,331.14,377.65Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 327.415px 378.964px 0px",
            }}
            id="ellq8fzdpkpk"
            className="animable"
          ></path>
          <path
            d="M294.36,352.93l-.1,4.82a7.55,7.55,0,0,0,7.78.36c.14-.29.63-5,.63-5Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 298.465px 355.974px 0px",
            }}
            id="el1vqiuert9t9"
            className="animable"
          ></path>
          <path
            d="M316.94,370.49s0,2.28-.08,3.59,1.47,3.28,5.47,3.22c2.8,0,4.78-.76,4.71-3.07l.07-3.33Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 321.984px 373.896px 0px",
            }}
            id="elj5zco4ykwr"
            className="animable"
          ></path>
          <path
            d="M290,312c.47-10.16,2.65-14.57,2.65-14.57s-.53-12.57-1.91-28c-2.1-23.45-.24-26.92,4.58-37.35,0,0,38.87-4.24,39.74,12.15,1.09,20.41.44,61.86-.25,69s-.54.54-2.58,15.08c-1.62,11.49-5.1,42.55-5.1,42.55a10.8,10.8,0,0,1-10.17-.41s-2.46-38.14-1.95-46.44c.61-10.13,1.24-12.7,1.24-12.7s-4-32.93-4.55-38.23c0,0-.83,9.45-1.52,16.64s-.76,13-2.57,27.84c-1.42,11.66-4.81,36.81-4.81,36.81a9.67,9.67,0,0,1-8.57-.8S289.61,320.17,290,312Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 312.764px 301.762px 0px",
            }}
            id="elfmm510ywrxu"
            className="animable"
          ></path>
          <path
            d="M311.75,354.46s-.1-5.63-7.69-6.57l-.44.24a6.58,6.58,0,0,1,3.8-2.81c2.54-.63,4.52.06,5.81,1.8S313.09,353.39,311.75,354.46Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: " 308.678px 349.775px 0px",
            }}
            id="eldq0qp2r169"
            className="animable"
          ></path>
          <path
            d="M311.68,273.12l-.5-6.73a54.54,54.54,0,0,1-12-6,16.13,16.13,0,0,0,9.68,7.34l1.21,6.61.1,15.45Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 305.43px 275.09px 0px",
            }}
            id="el9e4rp6mfym"
            className="animable"
          ></path>
          <path
            d="M297.72,141.06c-2.13,2.66-17.88,28-20.18,32.77s-2.86,7.83.78,11.67c5.47,5.77,19.26,19.69,19.26,19.69l7.72-18.42-14.32-9,14-29.63Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 290.501px 173.125px 0px",
            }}
            id="el0o2y4e8b8z9f"
            className="animable"
          ></path>
          <path
            d="M291,177.78s-3.92-1.38-7.19.74c0,0,2.58-3.64,7.92-2.27Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: " 287.77px 177.231px 0px",
            }}
            id="eljpw9ya4r3di"
            className="animable"
          ></path>
          <path
            d="M305.67,185.32,293,179c-4.67-.67-10.75,6.63-10.58,12.23l11.11,9.8Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 294.043px 189.994px 0px",
            }}
            id="el5cgvg0sa0tp"
            className="animable"
          ></path>
          <path
            d="M307.51,175.93l-.8,8.81h0c-2,.62-1.63,3.41-.46,5.13l-.23,2.59,13,1.17,1.95-14.87Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 313.131px 184.78px 0px",
            }}
            id="elgpitsufayo"
            className="animable"
          ></path>
          <path
            d="M293.25,191.14c1.44-3.91,7.12-6.92,10.57-6.65l2.89.25c-.8,1.6.36,2.74,2.46,3.35,2.7.78,7.67,1.22,10.6-.51l.09-.75s5.53,1.58,7.16,2.19c4.58,1.72,6.09,2.61,10.83,14.92,2,5.27.78,10.73-4.68,13.71-.41,3.26-.87,8.39-.87,8.39a187.15,187.15,0,0,1,3.31,21.17s-2.88,6.53-22.83,5.43c-15.45-.85-22.64-8.67-22.64-8.67.38-3.79,2.78-9.84,7.7-21.26C292,206.29,291.11,197,293.25,191.14Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 314.447px 218.619px 0px",
            }}
            id="elus7ycku49vj"
            className="animable"
          ></path>
          <path
            d="M375.73,183h-.05a3.36,3.36,0,0,1,1.9-6.33.13.13,0,0,1,.12.15.12.12,0,0,1-.14.11,3.1,3.1,0,0,0-1.75,5.83.13.13,0,0,1,.05.18A.12.12,0,0,1,375.73,183Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: " 375.777px 179.826px 0px",
            }}
            id="el7csgz66e9rm"
            className="animable"
          ></path>
          <path
            d="M373.69,180.28l.76.94a3.89,3.89,0,0,0,1.42,1.76l.75.93.57-.45h0a1.1,1.1,0,0,0,.38-1.17,3.65,3.65,0,0,0-2.07-2.57,1.11,1.11,0,0,0-1.23.13h0Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 375.651px 181.751px 0px",
            }}
            id="elqunskaljs4"
            className="animable"
          ></path>
          <path
            d="M375.45,184c1,.38,1.65-.16,1.49-1.2a3.67,3.67,0,0,0-2.08-2.56c-1-.38-1.64.16-1.48,1.2A3.65,3.65,0,0,0,375.45,184Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 375.16px 182.12px 0px",
            }}
            id="elf1gz1toe8r8"
            className="animable"
          ></path>
          <path
            d="M372.93,181.76l2.09,2.59.89-.72h0a.81.81,0,0,0,.27-.84A2.61,2.61,0,0,0,374.7,181a.81.81,0,0,0-.88.08h0Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 374.569px 182.628px 0px",
            }}
            id="elipdcxrssbh"
            className="animable"
          ></path>
          <path
            d="M353.67,190.93l1,3.21h0v0h0c.51,1.57,2.06,2.82,4.52,3.36,5,1.09,11.74-1.05,15.16-4.79,1.7-1.86,2.25-3.77,1.77-5.35h0v0h0l-1-3.21-1.27.64a8.51,8.51,0,0,0-2.24-.81c-5-1.09-11.74,1.05-15.16,4.79a8.71,8.71,0,0,0-1.36,1.94Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 364.978px 190.74px 0px",
            }}
            id="elatrchumpiwr"
            className="animable"
          ></path>
          <g id="eljgrb3qtm9s">
            <path
              d="M353.67,190.93l1,3.21h0v0h0c.51,1.57,2.06,2.82,4.52,3.36,5,1.09,11.74-1.05,15.16-4.79,1.7-1.86,2.25-3.77,1.77-5.35h0v0h0l-1-3.21-1.27.64a8.51,8.51,0,0,0-2.24-.81c-5-1.09-11.74,1.05-15.16,4.79a8.71,8.71,0,0,0-1.36,1.94Z"
              style={{
                opacity: "0.3",
                transformOrigin: " 364.978px 190.74px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M376.88,183.36a3.38,3.38,0,0,1-1.2-.35.13.13,0,0,1-.05-.18.13.13,0,0,1,.18-.06,3,3,0,0,0,1.1.33,3.1,3.1,0,0,0,.65-6.16.12.12,0,0,1-.12-.14.13.13,0,0,1,.14-.12,3.36,3.36,0,1,1-.7,6.68Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: " 378.154px 180.035px 0px",
            }}
            id="el4mir4ibk37m"
            className="animable"
          ></path>
          <path
            d="M370.58,180.74c-4.95-1.1-11.74,1-15.17,4.79s-2.18,7.66,2.77,8.76,11.74-1.06,15.17-4.8S375.53,181.83,370.58,180.74Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 364.38px 187.513px 0px",
            }}
            id="elet19uj46y"
            className="animable"
          ></path>
          <g id="ele4j8clip80e">
            <path
              d="M370.58,180.74c-4.95-1.1-11.74,1-15.17,4.79s-2.18,7.66,2.77,8.76,11.74-1.06,15.17-4.8S375.53,181.83,370.58,180.74Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 364.38px 187.513px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M357,187a15.41,15.41,0,0,1,13.09-4.14,5.24,5.24,0,0,1,2.36,1.08,1.83,1.83,0,0,1,.6,1.71,5.11,5.11,0,0,1-1.33,2.37,15.41,15.41,0,0,1-13.09,4.14,5.09,5.09,0,0,1-2.35-1.07l-.1-.09C354.88,189.64,356.32,187.76,357,187Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 364.367px 187.51px 0px",
            }}
            id="elh4va6ktzetc"
            className="animable"
          ></path>
          <g id="el0fp2defrfytc">
            <path
              d="M357,187a15.41,15.41,0,0,1,13.09-4.14,5.24,5.24,0,0,1,2.36,1.08,1.83,1.83,0,0,1,.6,1.71,5.11,5.11,0,0,1-1.33,2.37,15.41,15.41,0,0,1-13.09,4.14,5.09,5.09,0,0,1-2.35-1.07l-.1-.09C354.88,189.64,356.32,187.76,357,187Z"
              style={{
                opacity: "0.5",
                transformOrigin: " 364.367px 187.51px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M357.53,188.62a15.45,15.45,0,0,1,13.09-4.14,5.24,5.24,0,0,1,2.36,1.08l.09.09a5.11,5.11,0,0,1-1.33,2.37,15.41,15.41,0,0,1-13.09,4.14,5.09,5.09,0,0,1-2.35-1.07l-.1-.09A5.1,5.1,0,0,1,357.53,188.62Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: " 364.635px 188.321px 0px",
            }}
            id="elz951iseocrc"
            className="animable"
          ></path>
          <path
            d="M363.18,188.33l-2.89,2.16c-.23.17,0,.34.35.21l3.85-1.58Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 362.344px 189.538px 0px",
            }}
            id="elsk3ii539xb"
            className="animable"
          ></path>
          <path
            d="M365.51,188.55l2.89-2.16c.23-.17,0-.34-.35-.21l-3.85,1.58Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 366.346px 187.342px 0px",
            }}
            id="elq8joxabnppr"
            className="animable"
          ></path>
          <path
            d="M365.54,189.15a3.17,3.17,0,0,1-2.82.19c-.65-.39-.46-1.12.43-1.61a3.17,3.17,0,0,1,2.82-.19C366.62,187.93,366.43,188.66,365.54,189.15Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 364.345px 188.44px 0px",
            }}
            id="elesyqj8kccy9"
            className="animable"
          ></path>
          <path
            d="M365.11,188.9a2,2,0,0,1-1.81.12c-.43-.25-.3-.72.28-1a2,2,0,0,1,1.81-.12C365.82,188.11,365.69,188.58,365.11,188.9Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 364.345px 188.46px 0px",
            }}
            id="elerzejeg5kn5"
            className="animable"
          ></path>
          <path
            d="M377,186.39a6.34,6.34,0,0,0-1.8-1.92l.83,2.64c.65,1.95-.77,4.51-2.18,6-.95,1-2.73,2.15-2.88,1.79-.2-.51.1-3-.41-5.26-.62-2.7-2.22-1.39-2.64.64-.23,1.11-1.43,3.94-1.77,6.09-.42,2.63.12,4.88-.67,6.78-.61,1.49-7,9.51-10.74,13.81-3.84-5.12-9-11.79-13.51-17.52-6.29-8.06-7.58-9.75-12.62-9.91-4,11.54,2.85,23.16,2.85,23.16s9.46,11.49,15.35,17.53c5.68,5.83,7.68,5.33,10.41,3S367,220.44,370,214.65s6.21-10.17,8-13.24C381,196.25,380.13,190.83,377,186.39Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 353.604px 209.662px 0px",
            }}
            id="ele0g1qoayqxf"
            className="animable"
          ></path>
          <path
            d="M327,189s4.72-.67,7.91,1.88a41.08,41.08,0,0,1,5.43,6c4.41,5.9,12.63,16.86,12.63,16.86a20.71,20.71,0,0,1-12.86,10s-8.08-8.45-11.1-12.64C323.67,203.71,324.22,193.13,327,189Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 338.953px 206.33px 0px",
            }}
            id="el47hkjx033gw"
            className="animable"
          ></path>
          <path
            d="M306.71,184.74s-6.46,2.86-7.76,7l-6.07-.76a14.2,14.2,0,0,1,7.71-6.24A11.16,11.16,0,0,1,306.71,184.74Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 299.795px 188.026px 0px",
            }}
            id="eljok0n5ezxp"
            className="animable"
          ></path>
          <g id="el2x460qn544w">
            <path
              d="M306.71,184.74s-6.46,2.86-7.76,7l-6.07-.76a14.2,14.2,0,0,1,7.71-6.24A11.16,11.16,0,0,1,306.71,184.74Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 299.795px 188.026px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M320.74,197.65S323.26,190,327,189a14.22,14.22,0,0,0-6.77-2.05,18,18,0,0,0-5.8,7.1Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 320.715px 192.3px 0px",
            }}
            id="el5sbj8w0wvmw"
            className="animable"
          ></path>
          <g id="elsb8tt6zbrmj">
            <path
              d="M320.74,197.65S323.26,190,327,189a14.22,14.22,0,0,0-6.77-2.05,18,18,0,0,0-5.8,7.1Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 320.715px 192.3px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M296.49,189c-3.6-.05-10.69,4.51-11.95,7.32s-6.23,39.9-3.14,43.62c3.87,4.66,21.65,15.22,30,14.92,6.86-.24,13.6-5.44,14.64-7.28,1.7-3-.6-44-2.79-47.49C319.67,194.53,301.09,189.08,296.49,189Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 303.517px 221.933px 0px",
            }}
            id="ely61ndrh66o"
            className="animable"
          ></path>
          <g id="elezx3rkww8yj">
            <path
              d="M319.33,196.69l-3.56,2.4c-3.59,2.07-5.53,7.52-5.47,20.57s-.19,30.73,1.9,32.6,6.3.59,6.55.52c3.75-1.6,6.59-4,7.26-5.18,1.7-3-.6-44-2.79-47.49A12.29,12.29,0,0,0,319.33,196.69Z"
              style={{
                opacity: "0.2",
                transformOrigin: " 318.449px 224.981px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <g id="elf7u5aafvck9">
            <path
              d="M324.79,249c-2.45,2.28-7.9,5.69-13.42,5.89-8.31.29-26.1-10.27-30-14.93-3.08-3.71,1.82-40.67,3.14-43.62s8.35-7.36,11.95-7.32,16.36,3.66,22.84,7.67l-3.56,2.4c-3.58,2.07-5.53,7.52-5.46,20.58s-.2,30.73,1.89,32.59,6.3.59,6.55.52A22,22,0,0,0,324.79,249Z"
              style={{
                opacity: "0.1",
                transformOrigin: " 302.58px 221.958px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M296.12,189c-4,0-9.94,3.22-11.95,6.34s-3.45,12.19-2,14.86,11.29,8,18,10.7c5.35,2.19,8.15,1.62,10,.27,1.2-.86,1.41-3.42,1.5-5.32.24-4.88-.16-7.49,2.78-10.36s8.19-5.28,9.08-3.12c0,0,1.19-3.25-4.9-6.39C308.6,190.8,301,189,296.12,189Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 302.602px 205.682px 0px",
            }}
            id="el9ate2017mlk"
            className="animable"
          ></path>
          <path
            d="M301.79,214.72l3.54,1.34s-.47,10.77-.45,15c0,0-.83,1.81-1.6,2.11s-1.78-1.73-1.94-3.26S301.42,218.37,301.79,214.72Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 303.31px 223.96px 0px",
            }}
            id="elchvt1cwt0st"
            className="animable"
          ></path>
          <path
            d="M301.69,215.56l3.6,1.24a.61.61,0,0,0,.85-.56l.14-1.73a1,1,0,0,0-.6-.92l-3.61-1.3a.6.6,0,0,0-.84.54l-.13,1.82A1,1,0,0,0,301.69,215.56Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 303.69px 214.545px 0px",
            }}
            id="eld4171ggn1s"
            className="animable"
          ></path>
          <path
            d="M303.05,228.11a1.72,1.72,0,0,1,1,1.5.7.7,0,0,1-1,.73,1.7,1.7,0,0,1-1-1.5C302.07,228.21,302.51,227.89,303.05,228.11Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: " 303.054px 229.226px 0px",
            }}
            id="elfeozi932sla"
            className="animable"
          ></path>
          <path
            d="M287,207l3.46,1.53s-1,10.73-1.22,14.94c0,0-.92,1.77-1.7,2s-1.69-1.82-1.78-3.35S286.45,210.62,287,207Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: " 288.106px 216.244px 0px",
            }}
            id="elcecwbzf9wh8"
            className="animable"
          ></path>
          <path
            d="M286.87,207.82l3.52,1.43a.61.61,0,0,0,.88-.51l.23-1.73a1,1,0,0,0-.54-.94l-3.54-1.49a.6.6,0,0,0-.87.5l-.23,1.81A.93.93,0,0,0,286.87,207.82Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: " 288.909px 206.914px 0px",
            }}
            id="ele3bcx4keli8"
            className="animable"
          ></path>
          <path
            d="M287.58,220.43a1.74,1.74,0,0,1,.91,1.55.7.7,0,0,1-1,.68,1.68,1.68,0,0,1-.9-1.55C286.59,220.48,287.05,220.18,287.58,220.43Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: " 287.54px 221.535px 0px",
            }}
            id="elg07i7sjxgyi"
            className="animable"
          ></path>
          <path
            d="M283.2,227.54c0,4.31-.12,6.09.07,8.16a5,5,0,0,0,2.49,4.17c2.09,1.48,11.1,6.22,13.76,7.49,3.26,1.54,6.81,2.57,6.76,0,0-2.21,0-6.91,0-8.52,0-2-1-3.27-5-5.14-3.83-1.77-12.36-6.57-14.72-7.64C284.56,225.19,283.21,226.25,283.2,227.54Z"
            style={{
              fill: "rgb(105, 183, 50)",
              transformOrigin: " 294.722px 237.334px 0px",
            }}
            id="elv9vjne1l3m9"
            className="animable"
          ></path>
          <path
            d="M329.34,158.81s6.81-8.78,1.75-13.54c-6-5.63-13.95-5.51-24.34-1.89-4.86,1.7-11.93,6.63-12.56,16.17-.48,7.37,20.06,12.8,19.59,17.84Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 313.571px 159.107px 0px",
            }}
            id="el7rcrw0spirq"
            className="animable"
          ></path>
          <path
            d="M331.09,162.64s2.78,4.46,2.39,4.92a7,7,0,0,1-2.25.9Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: " 332.304px 165.55px 0px",
            }}
            id="el7uxqityjn1l"
            className="animable"
          ></path>
          <path
            d="M322.59,148.48c2.78,1.54,7.59,4.37,8.56,14.8,1,10.71-1.47,14.36-3,15.72-1,.91-6.08,1.12-8.7.23-3.29-1.12-10.36-4.85-13.57-10.45-3.78-6.59-4.36-15.26.29-18.52C312.75,145.67,320.23,147.19,322.59,148.48Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 317.122px 163.482px 0px",
            }}
            id="els22tja2h8v"
            className="animable"
          ></path>
          <path
            d="M320.82,179.56a15.89,15.89,0,0,0,6.8-.25,12.5,12.5,0,0,1-6.7-1.92Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: " 324.22px 178.602px 0px",
            }}
            id="elwo5jd4hgjg"
            className="animable"
          ></path>
          <path
            d="M322.45,161.09a10.62,10.62,0,0,0,6.8-8.56c1.05-6.79-7.44-9.67-7.44-9.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 325.575px 151.975px 0px",
            }}
            id="elzr7nlndgsta"
            className="animable"
          ></path>
          <path
            d="M321.55,170.43c-.56.89-2.75,1.73-5.06-.67s-2.23-6.76,1.09-7.77,4.91,2.84,4.91,2.84c3.12-6.07.92-15.88.92-15.88s-7.24-7.45-19-3.89c-6.31,1.91-9.55,8.5-10.25,13.41s-2.59,13.68-.14,16.86,11.91,8.1,20.41,7.69,8.52-2.09,8.52-2.09l-1.3-10.73S321.63,170.29,321.55,170.43Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: " 308.483px 163.57px 0px",
            }}
            id="eld1fsc8eu2fv"
            className="animable"
          ></path>
          <path
            d="M297.72,141.06c3.3-4,8.53-3.07,12.6-2.4s10,1.24,9,4-4,5.23-11,4.55-8.29,0-9.86,1.85C298.42,149,293.84,147.16,297.72,141.06Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: " 307.796px 143.561px 0px",
            }}
            id="ells6q11onaq"
            className="animable"
          ></path>
        </g>
      </g>
    </svg>
  );
}
